/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingRuleCommitmentUnshare extends models.BillingRule {
    constructor() {
        super();
        this.setDiscriminator("BillingRuleCommitmentUnshare");
    }

    getFixupPrototypeFunction() { return BillingRuleCommitmentUnshare.fixupPrototype; }

    static newInstance(model: Partial<BillingRuleCommitmentUnshare>): BillingRuleCommitmentUnshare {
        let obj = Object.assign(new BillingRuleCommitmentUnshare(), model);
        BillingRuleCommitmentUnshare.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingRuleCommitmentUnshare>): BillingRuleCommitmentUnshare {
        if (!model) return null;
        return BillingRuleCommitmentUnshare.newInstance(<BillingRuleCommitmentUnshare> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingRuleCommitmentUnshare) {
        if (!obj) return;

        models.BillingRuleCommitmentUnshare.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingRuleCommitmentUnshare): boolean {
        if (models.BillingRule.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingRuleCommitmentUnshare.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.unshare_percentage_from_source === undefined) {
            this.unshare_percentage_from_source = 0;
        }
        if (this.benefit_details) {
            for (let val of this.benefit_details) {
                models.BenefitDetails.fixupPrototype(val);
            }
        }
        if (this.benefit_distribution_rules) {
            for (let val of this.benefit_distribution_rules) {
                models.BillingRuleBenefitDistributionBase.fixupPrototype(val);
            }
        }
    }

    /**
     * Actual metric to copy the cost from. If not set, the source metric will be the raw_list_cost.
     */
    source_metric: string;

    /**
     * Metric where adjusted cost will be written.
     */
    target_metric: string;

    /**
     * List of benefit details to unshare.
     */
    benefit_details: Array<models.BenefitDetails>;

    /**
     * Percentage of the benefit to unshare from the source.
     */
    unshare_percentage_from_source: number;

    /**
     * Distribution rules for the unshared benefits. Can include share or share-to-self rules.
     */
    benefit_distribution_rules: Array<models.BillingRuleBenefitDistributionBase>;

}
